import { Globe, MapPin, Shield } from "lucide-react";

export const KNOWN_SOURCES = ["GOOGLE_PLACES", "OSM", "RIVM"] as const;
export type KnownSource = (typeof KNOWN_SOURCES)[number];

export function SourceBadge({ src }: { src: string }) {
  if (src === "GOOGLE_PLACES") {
    return (
      <span
        title="Bron: Google Places"
        className="w-[22px] h-[22px] rounded-full bg-muted flex items-center justify-center shrink-0"
      >
        <Globe className="w-3 h-3 text-muted-foreground" />
      </span>
    );
  }
  if (src === "OSM") {
    return (
      <span
        title="Bron: OpenStreetMap"
        className="w-[22px] h-[22px] rounded-full bg-muted flex items-center justify-center shrink-0"
      >
        <MapPin className="w-3 h-3 text-muted-foreground" />
      </span>
    );
  }
  if (src === "RIVM") {
    return (
      <span
        title="Bron: RIVM"
        className="w-[22px] h-[22px] rounded-full bg-muted flex items-center justify-center shrink-0"
      >
        <Shield className="w-3 h-3 text-muted-foreground" />
      </span>
    );
  }
  return null;
}
